import { Button, ButtonProps } from '@mui/material';
import { ReactNode } from 'react';

export interface ICancelButtonProps {
    children: ReactNode
}

export default function CancelButton({ children, ...rest }: ICancelButtonProps & ButtonProps) {
    return (
        <Button variant="outlined"  {...rest} sx={{ minWidth:'92px', ...rest?.sx }}>{children}</Button>
    );
}
